import React from 'react';

import { toInteger } from 'lodash';
import { useParams } from 'react-router-dom';

import {
  PageContainer,
} from '../index.styles';
import LegacyMarkingPage from '../LegacyMarkingPage';
import MarkingPage from '../MarkingPage';

const TeacherMarkingPage = () => {
  const { subject, student, exam, attempt } = useParams();

  return (
    <PageContainer>
      {(subject && exam && student && attempt) && (
        <MarkingPage
          subject={subject}
          examId={exam}
          studentId={student}
          attemptNum={toInteger(attempt)}
        />
      )}
      {!(subject && exam && student && attempt) && (
        <LegacyMarkingPage />
      )}
    </PageContainer>
  );
};

export default TeacherMarkingPage;
